/**
 * @generated SignedSource<<7d1bd7d1c4d4c8dfbe449d25c72ca350>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "companyId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userFilter"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "companyId"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v3 = {
        "kind": "Variable",
        "name": "where",
        "variableName": "userFilter"
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v5 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "kind": "Literal",
            "name": "order",
            "value": {
                "timestampId": "DESC"
            }
        },
        (v3 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "CompanyUsersPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Company",
                    "kind": "LinkedField",
                    "name": "admin_company",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "args": [
                        (v3 /*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "UserTablePanel_query"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "CompanyUsersPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Company",
                    "kind": "LinkedField",
                    "name": "admin_company",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v5 /*: any*/),
                    "concreteType": "UserConnection",
                    "kind": "LinkedField",
                    "name": "admin_users",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "employeeId",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "fullName",
                                            "storageKey": null
                                        },
                                        (v4 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Company",
                                            "kind": "LinkedField",
                                            "name": "company",
                                            "plural": false,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v2 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "email",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "timestampId",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v5 /*: any*/),
                    "filters": [
                        "where"
                    ],
                    "handle": "connection",
                    "key": "UserTable_query_admin_users",
                    "kind": "LinkedHandle",
                    "name": "admin_users"
                }
            ]
        },
        "params": {
            "cacheID": "bfe2b47e42b3265396766df2375a4fd9",
            "id": null,
            "metadata": {},
            "name": "CompanyUsersPageQuery",
            "operationKind": "query",
            "text": "query CompanyUsersPageQuery(\n  $companyId: ID!\n  $userFilter: UserFilterInput\n) {\n  admin_company(id: $companyId) {\n    name\n    id\n  }\n  ...UserTablePanel_query_FsPhM\n}\n\nfragment CompanyLink_company on Company {\n  id\n  name\n}\n\nfragment UserLink_user on User {\n  ...UserNameLabel_user\n  id\n}\n\nfragment UserNameLabel_user on User {\n  employeeId\n  fullName\n}\n\nfragment UserTablePanel_query_FsPhM on Query {\n  ...UserTable_query_FsPhM\n}\n\nfragment UserTable_query_FsPhM on Query {\n  admin_users(first: 50, order: {timestampId: DESC}, where: $userFilter) {\n    edges {\n      node {\n        ...UserLink_user\n        company {\n          ...CompanyLink_company\n          id\n        }\n        email\n        timestampId\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "fafd8cedab555faa015092bde3fabb45";
export default node;
